import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableString } from '../utils/wire-value-utils';

/**
 * A drone model, as `GET /lookups/drone-models` returns it
 * (`{ id, manufacturerId, modelName, maxTakeoffWeightLbs, imageUrl }`).
 * Read-only lookup data for dropdowns (the web never writes it), so text falls back to '' for display.
 * Mirrors hub `data-models/drone-model.ts`.
 */
export class DroneModel extends Base {
  manufacturerId: string;
  modelName: string;
  maxTakeoffWeightLbs?: number;
  imageUrl?: string;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.manufacturerId = nullableString(source['manufacturerId']) ?? '';
    this.modelName = nullableString(source['modelName']) ?? '';
    const weight = source['maxTakeoffWeightLbs'];
    this.maxTakeoffWeightLbs = typeof weight === 'number' && Number.isFinite(weight) ? weight : undefined;
    this.imageUrl = nullableString(source['imageUrl']) ?? undefined;
  }
}
